<template>
  <div>
    <div class="loading" v-if="fetchData">
      <load-data></load-data>
    </div>
    <div class="coursesOptions" v-else>
      <b-row>
        <b-col md="12">
          <b-card>
            <div class="courseDetails d-flex justify-content-between flex-wrap">
              <div class="subgroup d-flex">
                <h6 class="text-info ml-2">
                  {{ usergroup_name }}
                </h6>
              </div>
            </div>
          </b-card>
          <br />
        </b-col>
        <b-col md="2">
          <b-list-group>
            <b-list-group-item :active="currentOption == 0" @click="switchUsergroupComponent('Activity', 0)">
              Activity Settings
            </b-list-group-item>
            <b-list-group-item :active="currentOption == 1" @click="switchUsergroupComponent('Reports', 1)">
              Report Signature Settings
            </b-list-group-item>
            <b-list-group-item :active="currentOption == 2"
              @click="switchUsergroupComponent('SurveyReportSettings', 2)">
              Survey Report Font Settings
            </b-list-group-item>
            <b-list-group-item :active="currentOption == 3" @click="switchUsergroupComponent('QuestionPaper', 3)">
              Question Paper Settings
            </b-list-group-item>
            <b-list-group-item :active="currentOption == 4" @click="switchUsergroupComponent('VisionAndMission', 4)">
              Vision And Mission
            </b-list-group-item>
            <b-list-group-item :active="currentOption == 5" @click="switchUsergroupComponent('Attainment', 5)">
              Attainment Calculation Method
            </b-list-group-item>
            <b-list-group-item :active="currentOption == 6" @click="switchUsergroupComponent('CourseFileHeader', 6)">
              Course File Header
            </b-list-group-item>
            <b-list-group-item :active="currentOption == 7" @click="switchUsergroupComponent('CourseFile', 7)">
              Course File
            </b-list-group-item>
            <b-list-group-item :active="currentOption == 8" @click="switchUsergroupComponent('SurveyPage', 8)">
              Survey Default Questions
            </b-list-group-item>
          </b-list-group>

        </b-col>
        <b-col md="10">
          <component v-bind:is="currentComponent" :usergroup_name="usergroup_name" :usergroup_id="usergroup_id">
          </component>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import Activity from "./ActivityNameSetting.vue";
import Reports from "./ReportSignatureSettings.vue";
import QuestionPaper from "./ExamQuestionPaperSettings.vue";
import SurveyReportSettings from "./SurveyReportSettings.vue";
import VisionAndMission from "./VisionAndMission.vue";
import Attainment from "./AttainmentCalculationMethods.vue";
import CourseFileHeader from "./CourseFileHeader.vue";
import CourseFile from "./CourseFile.vue";
import SurveyPage from "./SurveyPage.vue";
export default {
  props: [
    "usergroup_name",
    "usergroup_id"
  ],
  async created() {
    this.currentComponent = 'Activity';
  },
  components: {
    Activity,
    Reports,
    QuestionPaper,
    VisionAndMission,
    Attainment,
    CourseFileHeader,
    SurveyReportSettings,
    CourseFile,
    SurveyPage
    // QuestionPaper,
  },
  data() {
    return {
      fetchData: false,
      currentOption: 0,
      currentComponent: "",
      course: {}
    };
  },
  computed: {
    getCustomNames() {
      return this.$store.getters.getCustomNamings;
    },
  },
  methods: {
    switchUsergroupComponent(selectedComponent, optionIndex) {
      this.currentComponent = selectedComponent;
      this.currentOption = optionIndex;
    },
  },
};
</script>

<style>
.coursesOptions .list-group .list-group-item {
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 10px;
  cursor: pointer;
  background-color: #007bff;
  color: #ffffff;
  border-radius: 10px;
}

.coursesOptions .list-group .list-group-item.active {
  color: #007bff;
  background-color: #ffffff;
}
</style>